/* src/app/common/components/menu-nav-bar/menu-nav-bar.component.scss */
:host {
  display: block;
}
ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
}
ul li:last-child ion-button ion-icon[slot=end] {
  display: none;
}
ul li ion-button {
  margin: 0;
  --padding-start: .5rem;
  --padding-end: .5rem;
  --border-radius: 0;
}
ul li ion-button ion-icon.home {
  font-size: 18px;
  vertical-align: text-bottom;
}
/*# sourceMappingURL=menu-nav-bar.component.css.map */
